export default function TrainingFormats() {
  const formats = [
    { icon: 'ri-user-star-line', title: 'Корпоративный тренинг', desc: 'Интенсивное обучение управленческой команды: 2–3 дня практики, реальные кейсы компании, отработка инструментов.' },
    { icon: 'ri-compasses-2-line', title: 'Стратегическая сессия', desc: 'Фасилитационная работа с топ-командой: анализ текущей ситуации, постановка целей и выработка плана развития.' },
    { icon: 'ri-group-line', title: 'Управленческая фасилитация', desc: 'Модерирование ключевых встреч руководства для принятия сложных решений и разрешения противоречий.' },
    { icon: 'ri-gamepad-line', title: 'Бизнес-игры', desc: 'Игровые форматы для отработки управленческих навыков в условиях, моделирующих реальные бизнес-ситуации.' },
    { icon: 'ri-user-3-line', title: 'Индивидуальный коучинг', desc: 'Персональная работа с руководителем: развитие конкретных компетенций, разбор сложных управленческих ситуаций.' },
    { icon: 'ri-vidicon-line', title: 'Онлайн-программа', desc: 'Дистанционное обучение руководителей с интерактивными модулями, практическими заданиями и онлайн-сессиями.' },
    { icon: 'ri-stack-line', title: 'Серия модулей', desc: 'Поэтапная программа на 2–4 месяца: каждый модуль — новый навык с практикой и закреплением между встречами.' },
    { icon: 'ri-heart-pulse-line', title: 'Долгосрочное сопровождение', desc: 'Поддержка управленческой команды в течение 6–12 месяцев: аудит, коучинг, корректировка подходов.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Форматы обучения руководителей
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Выберите формат под задачи бизнеса. Все программы адаптируются под отрасль, уровень руководителей и цели компании.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {formats.map((format, i) => (
            <div key={i} className="bg-white p-6 rounded-xl hover:ring-2 hover:ring-teal-200 transition-all group text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${format.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{format.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{format.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}